import { AppChannel, Channel } from "@/config/channel"
import Cookies from "js-cookie"
import { getAuthType } from "./auth-type"
import { getSearchParamsForLocation } from "./router-helpers"
import { isHttpOrHttpsUrl } from "./url"

function getChannel(siteidParam: string | null) {
  const numericSiteId = parseInt(siteidParam ?? "", 10)
  return !isNaN(numericSiteId)
    ? (numericSiteId as Channel)
    : AppChannel.PortaleWebFullResponsiveWwwSisalIt
}

function getCancelCallbackUrl(
  cancelCallbackUrlParam: string | null,
  channel: Channel,
) {
  if (cancelCallbackUrlParam && isHttpOrHttpsUrl(cancelCallbackUrlParam)) {
    return cancelCallbackUrlParam
  }

  const defaultCancelCallbackUrl =
    channel === AppChannel.PortaleWebFullResponsiveWwwSisalIt
      ? typeof window !== "undefined"
        ? window.APP_MAIN_SITE_HOMEPAGE
        : ""
      : "https://appmobile.sisal.it/?appFunc=close"

  return defaultCancelCallbackUrl
}

const getConfigParams = (defaultParams: URLSearchParams | null = null) => {
  const isWindowDefined = typeof window !== "undefined"
  const searchParams = getSearchParamsForLocation(
    isWindowDefined ? window.location.search : "",
    defaultParams,
  )

  const siteIdParam = searchParams.get("siteid") || searchParams.get("siteId")
  const codicePromozioneParam =
    searchParams.get("codicePromozione") || searchParams.get("codicepromozione")
  const flowParam = searchParams.get("flow")
  const mppartnerParam = searchParams.get("mppartner")
  const camidParam = searchParams.get("camid")
  const pidParam = searchParams.get("pid")
  const affidParam = searchParams.get("affid")
  const cliidParam = searchParams.get("cliid")
  const pdvParam = searchParams.get("pdv")
  const jumpToParam = searchParams.get("jumpto")
  const cancelcallbackurlParam =
    searchParams.get("cancelcallbackurl") ??
    searchParams.get("cancelCallbackUrl")

  const endCallbackUrlParam =
    searchParams.get("endcallbackurl") ??
    searchParams.get("endCallbackUrl") ??
    (isWindowDefined ? window.APP_MAIN_SITE_HOMEPAGE : "")

  const errorCallbackUrlParam = searchParams.get("errorcallbackurl")
  const authType = getAuthType()

  const channel = getChannel(siteIdParam)
  const flow = flowParam ?? ""
  const intcmp = searchParams.get("intcmp") ?? ""

  return {
    channel,
    cancelCallbackUrl: getCancelCallbackUrl(cancelcallbackurlParam, channel),
    endCallbackUrl: endCallbackUrlParam,
    fromPdv: pdvParam === "true",
    codicePromozione: codicePromozioneParam ?? "",
    mppartner: mppartnerParam ?? Cookies.get("MPPARTNER") ?? null,
    camid: camidParam,
    pid: pidParam,
    affid: affidParam,
    cliid: cliidParam,
    errorcallbackurl: errorCallbackUrlParam ?? "",
    jumpTo: jumpToParam ?? "",
    flow,
    intcmp,
    authType,
  }
}

export { getConfigParams }
